export const HEADING = "Next, let's choose a benefit amount";

export const LIST_ITEMS: string[] = [
  'The maximum amount available is usually around 60% of your income',
  'If YOU pay the premium, the benefit is TAX-FREE',
  'If your employer pays the premium, the benefit is taxable',
  "If you already have existing LTD coverage, that affects the amount you're eligible for",
];
